export const getCurrentAppLn = state => state.app.currentLanguage;
export default { getCurrentAppLn };
